import TaxonomyDepartment from '../implementations/Taxonomy/Department';
import TaxonomyProjectCategories from '../implementations/Taxonomy/ProjectCategories';

const mappers = {
  department: TaxonomyDepartment,
  project_categories: TaxonomyProjectCategories,
};

export default mappers;
